/**
 * Created by zhyp on 2015/9/23.
 */
"use strict";
angular.module('pieceMgr.multiDocList',["pieceMgr.multiDocListDir"]);